import React from 'react';
import SideNavBar from '../../components/headers/sidenavbar/SideNavBar';
import UserData from '../../components/headers/topnavbar/UserData';
import HelpChild from '../../components/helpchild/HelpChild';

export default function Help() {
    return (
        <>
            <div id="wrapper">
                <SideNavBar />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <UserData />
                        <div className="container-fluid">
                            <HelpChild />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
